import { useRouteError } from "react-router-dom";
import NotFound from "./NotFound";
import Exception from "./Exception";

export default function ErrorBoundary() {
  const err: any = useRouteError();

  if (err["status"] === 404) {
    return <NotFound />;
  } else {
    return <Exception />;
  }
}
